import momentTZ from 'moment-timezone'

export const stringToSlug = (str) => {
  str = str.replace(/^\s+|\s+$/g, '')
  str = str.toLowerCase()
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
  const to = 'aaaaeeeeiiiioooouuuunc------'
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }

  str = str.replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+/, '') // trim - from start of text
    .replace(/-+$/, '') // trim - from end of text

  return str
}

export const formatNumber = (value, subfix = '') => {
  value = Number(value)
  if (value && !Number.isNaN(value)) {
    value = Math.ceil(value)
    return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${subfix}`
  } else {
    return 0 + subfix
  }
}
export const formatMoney = (value) => {
  return formatNumber(value, 'SPTCOIN')
}


export const convertAlias = (str) => {
  str = str.replace(/^\s+|\s+$/g, '')
  str = str.toLowerCase()
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
  const to = 'aaaaeeeeiiiioooouuuunc---.--'
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }
  str = str.replace(/[^.a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+/, '') // trim - from start of text
    .replace(/-+$/, '') // trim - from end of text

  return str
}

const num2Word2 = function() {
  const t = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'], r = function(r, n) {
    let o = '', a = Math.floor(r / 10), e = r % 10
    return a > 1 ? (o = ' ' + t[a] + ' mươi', 1 === e && (o += ' mốt')) : 1 === a ? (o = ' mười', 1 === e && (o += ' một')) : n && e > 0 && (o = ' lẻ'), 5 === e && a >= 1 ? o += ' lăm' : 4 === e && a >= 1 ? o += ' tư' : (e > 1 || 1 === e && 0 === a) && (o += ' ' + t[e]), o
  }, n = function(n, o) {
    // eslint-disable-next-line no-redeclare
    var a = '', e = Math.floor(n / 100), n = n % 100
    return o || e > 0 ? (a = ' ' + t[e] + ' trăm', a += r(n, !0)) : a = r(n, !1), a
  }, o = function(t, r) {
    // eslint-disable-next-line no-redeclare
    var o = '', a = Math.floor(t / 1e6), t = t % 1e6
    a > 0 && (o = n(a, r) + ' triệu', r = !0)
    // eslint-disable-next-line no-redeclare
    var e = Math.floor(t / 1e3), t = t % 1e3
    return e > 0 && (o += n(e, r) + ' ngàn', r = !0), t > 0 && (o += n(t, r)), o
  }
  return {
    convert: function(r) {
      r = Number(r);
      if (Number.isNaN(r) || r == 0) return 'Không Việt Nam đồng.'
      let pre = ''
      if (r < 0) {
        pre = 'Trừ '
        r = Math.abs(r)
      }
      var n = '', a = '', ty = 0
      do {ty = r % 1e9, r = Math.floor(r / 1e9), n = r > 0 ? o(ty, !0) + a + n : o(ty, !1) + a + n, a = ' tỷ'} while (r > 0)
      return pre + n.trim().charAt(0).toUpperCase() + n.trim().slice(1) + ' Việt Nam đồng.'
    },
  }
}()

export const dateFormat = (value, formatString = 'HH:mm:ss, DD-MM-YYYY') => {
  const date = momentTZ(value)
  return date.isValid() ? date.format(formatString) : '00:00:00, 00-00-0000'
}
export const toMoneyString = num2Word2.convert

export const downloadGmails = ({ gmails, fileType = 'txt', fileName, includeDate = false }) => {
  if (!fileName) {
    fileName = gmails.length + 'gmails' + momentTZ().format('YYYYMMDDHHmmss') + '.' + fileType.toLocaleLowerCase()
  } else if (fileName.split('.').pop().toLocaleLowerCase() !== fileType.toLocaleLowerCase()) {
    fileName = fileName + '.' + fileType.toLocaleLowerCase()
  }
  const element = document.createElement('a')
  let href = ''
  const formatUsername = (username) => {
    return username.includes('@gmail.com') ? username : username + '@gmail.com'
  }
  const genFileContent = (fence = '|', br = '\n') => {
    return gmails
      .map(({ username, password, recovery, createdAt }) =>
        [formatUsername(username), password, recovery, includeDate ? createdAt : null].filter(Boolean).join(fence),
      )
      .join(br)
  }
  switch (fileType.toLocaleLowerCase()) {
    case 'txt':
      href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(genFileContent('|'))
      break
    case 'csv':
      href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(genFileContent(','))
      break
  }
  element.setAttribute('href', href)
  element.setAttribute('download', fileName)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
